/* eslint-disable max-len */
const HTTP_URL_REGEX = /^https?:\/\/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}(?::\d{1,5})?(?:[/?#][^\s]*)?$/i

export const validators = {
  isRequired: (val) => !!(val && val.length),
  isOnlynumber: (val) => (val ? /^[0-9]*$/.test(val) : true),
  noNumbersNoSpecialCharactersAlone: (val) => /[^0-9\W]/.test(val),
  isNumeric: (val) => /\D/.test(val),
  isAlphabetic: (val) => /^[\p{L}\s]+$/ui.test(val) || val === '',
  isAlphaNumeric: (val) => /^[a-zA-Z0-9\s\W]*$/i.test(val),
  noSpecialCharactersAlone: (val) => !/^[\W]*$/i.test(val),
  isFiscalCode: (val) =>
    val.length > 0
      ? /^(?:[A-Z]){3}(?:[A-Z]){3}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-ILMZ]{1}(?:[0-9L-MP-V]){3})(?:[A-Z]{1})$/i.test(
        val
      )
      : true,
  isPan: (val) => (val.length > 0 ? /^\d{13,19}$/i.test(val) : true),
  isMaskedPan: (val) => (val.length > 0 ? /^[0-9]{6}[*]{6}[0-9]{4}$/i.test(val) : true),
  isMaskedAmexPan: (val) => (val.length > 0 ? /^[0-9]{6}[*]{5}[0-9]{4}$/i.test(val) : true),
  isMaskedAllPan: (val) => (val.length > 0 ? /^[0-9]{8}[*]{4}[0-9]{4}$/i.test(val) : true),
  isEmail: (val) => val 
    ?  /^[\p{L}\p{N}\p{M}_%+-]+(?:\.[\p{L}\p{N}\p{M}_%+-]+)*@(?:[\p{L}\p{N}\p{M}0-9](?:[\p{L}\p{N}\p{M}0-9-]{0,61}[\p{L}\p{N}\p{M}0-9])?\.)+[\p{L}\p{N}\p{M}0-9](?:[\p{L}\p{N}\p{M}0-9-]{0,61}[\p{L}\p{N}\p{M}0-9])?$/u.test( val)
    : true,
  isDate: (val) => /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/i.test(val) || val === '',
  isTimeHHMM: (val) => /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/i.test(val) || val === '',
  isTimeHHMMSS: (val) => /(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)/i.test(val) || val === '',
  isIpAddress: (val) =>
    /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([1-9]|[1-2][0-9]|3[0-2]))?$/.test(
      val
    ),
  isBin: (val) => (val.length > 0 ? /^\d{6,8}$/i.test(val) : true),
  maxLength: (v, maxLength) => (v ? v.length <= maxLength : true),
  minLength: (v, maxLength) => (v ? v.length >= maxLength : true),
  isCountryCode: (v) => (v ? /^\+[0-9]{1,3}$/.test(v) : true),
  isMobilePhone: (v) => (v ? /^[0-9]{9,15}$/.test(v) : true),
  checkNumbersWithPlus: (v) => (v ? /^\+\d{10,18}$/.test(v) : true),
  cvvControl: (v) => (v ? /^[\d]{3,4}$/.test(v) : true),
  panGenericTest: (v) => (v ? /^\d{13,19}$/.test(v) : true),
  isAmexPan: (v) => (v ? /^3[47][0-9]{13}$/.test(v) : true)
}

export const maskedEmail = (val) => (val ? val.replace(/^(.{0})[^@]+/, '***********') : '-')

export const maskedPanValidator = (ev) => {
  const { value } = ev.target
  const valLength = value.length
  const isAmex = value.startsWith('34') || value.startsWith('37')

  const maskLength = isAmex ? 5 : 4
  const firstMaskPosition = isAmex ? 6 : 8 // first char: 6 for amex, 8 for others
  const unmaskPosition = isAmex ? 10 : 11 // when deleting, it removes the asterisks en bloc

  if (valLength === firstMaskPosition) {
    return (ev.target.value += '*'.repeat(maskLength))
  } else if (valLength === unmaskPosition) {
    // when deleting, it removes the asterisks en bloc
    return (ev.target.value = ev.target.value.slice(0, -maskLength))
  }
  return ev.target.value
}

export const AddSymbol = (str, symbol, index) => [str.slice(0, index), symbol, str.slice(index)].join('')

export const addDateSymbol = (ev, symbol = '-') => {
  const { value } = ev.target
  const valLength = value.length
  if (valLength === 2 || valLength === 5) {
    ev.target.value += symbol
  }
  if (valLength === 3 && value.charAt(2) !== symbol) {
    ev.target.value = AddSymbol(ev.target.value, symbol, 2)
  }
  if (valLength === 6 && value.charAt(5) !== symbol) {
    ev.target.value = AddSymbol(ev.target.value, symbol, 5)
  }
}

export const addTimeSymbol = (value) => {
  // Rimuovi qualsiasi carattere non numerico (salvo i ":")
  let newValue = value.replace(/[^0-9:]/g, '')

  // Gestire l'aggiunta del ":" solo se l'utente sta inserendo caratteri, non durante la cancellazione
  if (newValue.length > 2 && newValue.length <= 4 && newValue.charAt(2) !== ':') {
    newValue = newValue.slice(0, 2) + ':' + newValue.slice(2)
  }

  if (newValue.length > 5 && newValue.length <= 7 && newValue.charAt(5) !== ':') {
    newValue = newValue.slice(0, 5) + ':' + newValue.slice(5)
  }

  return newValue
}

export const isAllowedCode = (val) => /^[0-9]{4}$/.test(val)

export const isValidHttpUrl = (value) => {
  if (!value) return true

  const normalizedValue = String(value).trim()
  if (!normalizedValue) return true

  return HTTP_URL_REGEX.test(normalizedValue)
}